import React from 'react'

import { createRegisterableComponent } from 'common/routing/page-definition'
import { FigCaption, FigCaptionProps } from './FigCaption'
import { getPublicationInfoFromRouteResolution } from 'component-library/templates/Publication/SharedPublication.routing'

export const FigCaptionRegistration = createRegisterableComponent(
    'figcaption',
    (props: FigCaptionProps, services) => {
        const publicationInfo = getPublicationInfoFromRouteResolution(services)

        if (publicationInfo.publication.kind !== 'article') {
            throw new Error('Article component rendered for non-article')
        }
        const heroImage = publicationInfo.publication.heroImage
        const byline = heroImage && heroImage.byline
        const credit = heroImage && heroImage.credit
        const captionText = heroImage && heroImage.captionText

        return (
            <FigCaption
                captionText={captionText}
                credit={credit}
                byline={byline}
                kind={props.kind}
                figcaptionLayout={props.figcaptionLayout}
                separatedFromMedia={props.separatedFromMedia}
            />
        )
    }
)
